import React from "react";
import ReactDOM from "react-dom";
import App from "./app";
import Routes from "./route-wrappers/Routes";
import { Auth } from "@akord/akord-js";
import { KEEP_SIGNED_IN } from "./handlers/auth/constants";

import "@rainbow-me/rainbowkit/styles.css";

let storage: Storage;
if (sessionStorage.getItem(KEEP_SIGNED_IN) === "false") {
  storage = sessionStorage;
} else {
  storage = localStorage;
}
Auth.configure({ env: "v2", storage: storage });

ReactDOM.render(<App component={Routes} />, document.getElementById("main"));
